export enum WarrantyTypeGroup {
  OUT_OF_WARRANTY = 'OutOfWarranty',
  UNDER_WARRANTY = 'UnderWarranty',
  UNDER_MANUFACTURER_WARRANTY = 'UnderManufacturerWarranty',
}
